import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@optiaxiom/react';

import { RUNTIME_ENV } from '@frontend/envConfig';
import { LeftNavbar } from '@frontend/features/leftNavbar';
import { useRouteDocumentTitle } from '@frontend/hooks/useDocumentTitle';
import { useOpalUser } from '@frontend/hooks/useOpalUser';

import { baseLayoutStyles, mainContentStyles } from './BaseLayout.css';

export function BaseLayout() {
  const { opalUser } = useOpalUser();
  useRouteDocumentTitle();

  useEffect(() => {
    if (!opalUser) {
      return;
    }

    if (RUNTIME_ENV === 'production' || RUNTIME_ENV === 'integration') {
      void import(/* webpackChunkName: "Userflow" */ '@frontend/userflow').then(
        ({ default: Userflow }) => {
          Userflow.init(opalUser, opalUser.userflow_token);
        }
      );
    }
  }, [opalUser]);

  return (
    <Box className={baseLayoutStyles}>
      {/* Fixed Left Navbar (preserved for backward compatibility) */}
      <LeftNavbar />
      {/* Main content area */}
      <Box className={mainContentStyles}>
        <Outlet />
      </Box>
    </Box>
  );
}
